"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wrapper = void 0;

var react_1 = require("@emotion/react");

var colorStyles = {
  yellow: react_1.css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    color: var(--yellow-700);\n    background-color: var(--yellow-50);\n    border-color: var(--yellow-200);\n  "]))),
  green: react_1.css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    color: var(--green-700);\n    background-color: var(--green-50);\n    border-color: var(--green-100);\n  "]))),
  gray: react_1.css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    color: var(--gray-700);\n    background-color: var(--gray-60);\n    border-color: var(--gray-400);\n  "]))),
  red: react_1.css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    color: var(--red-500);\n    background-color: var(--red-50);\n    border-color: var(--red-100);\n  "])))
};

var wrapper = function wrapper(color) {
  return react_1.css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  padding: 3px 5px;\n  border-style: solid;\n  border-width: 1px;\n  border-radius: 4px;\n  font-weight: bold;\n  font-size: 13px;\n  letter-spacing: -0.4px;\n  ", ";\n"])), colorStyles[color]);
};

exports.wrapper = wrapper;